import React from 'react';

const operators_logo = operator => {
  return operator.logo_url && operator.logo_url !== 'false' ? (
    <img
      src={operator.logo_url}
      className="provider-img"
      alt={`${operator.name}`}
      title={`${operator.name}`}
    />
  ) : (
    <span className="provider-img-substitute">{operator.name}</span>
  );
};

const Operator = props => {
  return (
    <span className="provider">
      <span className="provider-img">{operators_logo(props.operator)}</span>
      <span className="provider-name">{props.operator.name}</span>
    </span>
  );
};

export default Operator;



// WEBPACK FOOTER //
// ./app/javascript/pages/offers/components/offers_list/components/with-hotel/components/operator.js